import { api } from '../index';

export const getAchievementsMainProgress = () => api.get('/achievements/progress');
export const getAchievementsDaily = () => api.get('achievements/daily');
export const getAchievementsOnce = params => api.get('achievements/once', { params });
export const getAchievementsHistory = params => api.get('achievements/history', { params });
export const getAchievementsLeaderboard = (id, params) => api.get(`achievements/leaderboard/${id}`, { params });
